import { render } from "./EditAccountDetailsModal.vue?vue&type=template&id=057ff02d&scoped=true"
import script from "./EditAccountDetailsModal.vue?vue&type=script&lang=js"
export * from "./EditAccountDetailsModal.vue?vue&type=script&lang=js"

import "./EditAccountDetailsModal.vue?vue&type=style&index=0&id=057ff02d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057ff02d"]])

export default __exports__